import { cmxURL } from '../endpoints';
import { updateLanguageBundle } from '@nackle/intl-tools';

const DEFAULT_LOCALE = 'en-US';

function CMXService( { access_token } ) {
    const fetchWithAuth = function( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };

    async function getBundle( bundleName, locales ) {
        const res = await fetchWithAuth(
            `${ cmxURL }/bundle/${ encodeURIComponent( bundleName ) }`,
            {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify( { locales } )
            }
        );

        const data = await res.json();

        if ( res.ok ) {
            return data;
        } else {
            throw data;
        }
    }

    async function loadBundles( bundleNames, locale = DEFAULT_LOCALE ) {
        const bundleData = await Promise.all( bundleNames.map(
            bundleName => getBundle( bundleName, [ locale ] )
        ) );

        let mergedBundle = bundleData[ 0 ].bundles[ locale ];
        for ( let i = 1; i < bundleData.length; i++ ) {
            mergedBundle = {
                ...mergedBundle,
                ...bundleData[ i ].bundles[ locale ]
            };
        }

        await updateLanguageBundle( locale, mergedBundle );
        return mergedBundle;
    }

    return {
        loadBundles
    };
}

export default CMXService;
